import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import './Main.css';

function Project({ name, description, link, tech = [], tag, org, accent }) {
  const accentClassMap = {
    research: 'project-card__tag--research',
    applied: 'project-card__tag--applied',
    systems: 'project-card__tag--systems',
    product: 'project-card__tag--product',
    automation: 'project-card__tag--automation',
    leadership: 'project-card__tag--leadership',
    backend: 'project-card__tag--backend',
  };
  const tagClass = accent ? accentClassMap[accent] || '' : '';
  return (
    <a className="project-card" href={link} target="_blank" rel="noreferrer">
      <div className="project-card__heading">
        <div>
          {tag ? (
            <p className={`project-card__tag ${tagClass}`}>
              {tag}
            </p>
          ) : null}
          <h3 className="project-card__title">{name}</h3>
          {org ? <p className="project-card__org">{org}</p> : null}
        </div>
        <FiArrowUpRight aria-hidden="true" />
      </div>
      <p className="project-card__desc">{description}</p>
      {tech.length ? (
        <div className="project-card__tech">
          {tech.map((item) => (
            <span key={item} className="project-card__chip">
              {item}
            </span>
          ))}
        </div>
      ) : null}
    </a>
  );
}

export default Project;
